import * as graphql from 'generated/graphql';

export function pickEvaluationSectionItem<T>(
	item: graphql.EvaluationSectionItem,
	choices: {
		competency: T;
		openQuestion: T;
		sentiment: T;
		signature: T;
		stars: T;
		title: T;
		paragraph: T;
		finalScore: T;
		reviewGoals: T;
		developmentPlan: T;
	},
): T {
	if (item.competency) {
		return choices.competency;
	}
	if (item.openQuestion) {
		return choices.openQuestion;
	}
	if (item.sentiment) {
		return choices.sentiment;
	}
	if (item.signature) {
		return choices.signature;
	}
	if (item.stars) {
		return choices.stars;
	}
	if (item.title) {
		return choices.title;
	}
	if (item.paragraph) {
		return choices.paragraph;
	}
	if (item.finalScore) {
		return choices.finalScore;
	}
	if (item.reviewGoals) {
		return choices.reviewGoals;
	}
	if (item.developmentPlan) {
		return choices.developmentPlan;
	}

	throw new Error('Unknown evaluation section item type');
}
